import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { SafeSvg } from './SafeSvg'

export const EaSafeIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={SafeSvg} {...props} />
)
